import Indicator, { IndicatorType } from '../types/Indicator'

const ExponentialMovingAverage: Indicator = {
  type: IndicatorType.OVERLAY,
  value: 'exponentialMovingAverage',
  label: 'Exponential Moving Average',
  nickname: 'EMA',
  fields: ['exponentialMovingAverage', 'exponentialMovingAverageAngle'],
  params: {
    field: 'close',
    period: 14,
  },
}

export default ExponentialMovingAverage
